import type { ReactNode } from 'react'
import { useGate } from '../data/useGate'

/**
 * The build scope picks the screens: Seva Mandir V1 (the roster's config.scope, from uc-core
 * SCOPE) or the full spec. V1 is the default scope, so while the roster is being read (or none is
 * downloaded yet) the V1 page shows — the full page only when the roster says FULL. No flash of
 * the full page on a V1 phone.
 */
export function ByScope({ v1, full }: { v1: ReactNode; full: ReactNode }) {
  const g = useGate()
  return <>{g.roster && !g.roster.config.v1 ? full : v1}</>
}
